import { cloudinary as cld } from "./cloudinary";

export { default as CldImage } from "./CldImage";
export { default as CldVideo } from "./CldVideo";
export { default as imageExtensions } from "./imageExtensions";
export { openCloudinaryUploadWidget } from "./openCloudinaryUploadWidget";
export { default as imageSizeOptions } from "./imageSizeOptions";

export default cld;
